import {Radio, RadioChangeEvent} from 'antd';
import React from 'react';

type RadioOptionType = {
    label: string;
    value: string;
};

type RadioValueType = string;

export interface RadioFilterProps {
    title?: string;
    options: Array<RadioOptionType>;
    value?: RadioValueType;
    onChange?: (value: RadioValueType) => void;
}

const RadioFilter: React.FC<RadioFilterProps> = (props) => {
    const {title, options, value, onChange} = props;

    const onOptionsChange = (e: RadioChangeEvent) => {
        onChange?.(e.target.value);
    };

    return (
        <div className="flex">
            <div className="mr-2">{title}</div>
            <Radio.Group onChange={onOptionsChange} value={value}>
                {options.map((item) => {
                    const value = typeof item === 'object' ? item.value : item;
                    const label = typeof item === 'object' ? item.label : item;
                    return (
                        <Radio value={value} key={`${value}`}>
                            {label}
                        </Radio>
                    );
                })}
            </Radio.Group>
        </div>
    );
};

export default RadioFilter;
